import { render, staticRenderFns } from "./DatabaseScreen.vue?vue&type=template&id=7949d5b4&"
import script from "./DatabaseScreen.vue?vue&type=script&lang=ts&"
export * from "./DatabaseScreen.vue?vue&type=script&lang=ts&"
import style0 from "./DatabaseScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports